module.exports = __webpack_public_path__ + "static/media/whocanuse2.4e92f6cf.PNG";